import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { LayoutDashboard, Send, LayoutTemplate, Users, Filter, Ban, ScrollText, Settings } from 'lucide-react'
import { cn } from '@/lib/utils'

const MarketingEmailSidebar = ({ collapsed }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const items = [
    { key: '/marketing-email', icon: LayoutDashboard, label: 'Dashboard' },
    { key: '/marketing-email/templates', icon: LayoutTemplate, label: 'Templates' },
    { key: '/marketing-email/campaigns', icon: Send, label: 'Campaigns' },
    { key: '/marketing-email/contacts', icon: Users, label: 'Contacts' },
    { key: '/marketing-email/segments', icon: Filter, label: 'Segments' },
    { key: '/marketing-email/suppression', icon: Ban, label: 'Suppression' },
    { key: '/marketing-email/audit-log', icon: ScrollText, label: 'Audit Log' },
    { key: '/marketing-email/settings', icon: Settings, label: 'Settings' },
  ]

  return (
    <nav className="space-y-0.5">
      {items.map((item) => {
        const Icon = item.icon
        const isActive = item.key === '/marketing-email'
          ? location.pathname === item.key
          : location.pathname.startsWith(item.key)
        return (
          <button
            key={item.key}
            onClick={() => navigate(item.key)}
            className={cn(
              'w-full flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors',
              isActive
                ? 'bg-gray-100 text-sidebar-foreground font-medium dark:bg-sidebar-accent dark:text-sidebar-accent-foreground'
                : 'text-sidebar-foreground/70 hover:bg-gray-100 hover:text-sidebar-foreground dark:hover:bg-sidebar-accent dark:hover:text-sidebar-accent-foreground',
              collapsed && 'justify-center px-2'
            )}
          >
            <Icon className="h-4 w-4 shrink-0" />
            {!collapsed && <span>{item.label}</span>}
          </button>
        )
      })}
    </nav>
  )
}

export default MarketingEmailSidebar
